/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * NOTE: More field to be added
 * @export
 * @interface TransmitFilter
 */
export interface TransmitFilter {
    /**
     * Filter expression
     * @type {string}
     * @memberof TransmitFilter
     */
    expression?: string;
}

/**
 * Check if a given object implements the TransmitFilter interface.
 */
export function instanceOfTransmitFilter(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TransmitFilterFromJSON(json: any): TransmitFilter {
    return TransmitFilterFromJSONTyped(json, false);
}

export function TransmitFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransmitFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'expression': !exists(json, 'expression') ? undefined : json['expression'],
    };
}

export function TransmitFilterToJSON(value?: TransmitFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'expression': value.expression,
    };
}

